import React from "react";

const SERVICES = [
  {
    id: "01",
    title: "Software Consulting",
    desc: "Technical audits, architecture reviews, and roadmaps that tell you what to build, what to retire, and what to leave alone.",
  },
  {
    id: "02",
    title: "Systems Integration",
    desc: "Middleware, APIs, and data pipelines that connect CRMs, ERPs, legacy databases, and third-party platforms into one reliable flow.",
  },
  {
    id: "03",
    title: "Complex System Design",
    desc: "Architecture for distributed, high-availability platforms — built to handle real load, real failure modes, and real growth.",
  },
  {
    id: "04",
    title: "Custom Application Build",
    desc: "Web and mobile applications built on the stack that fits your team, not the one that's trending.",
  },
  {
    id: "05",
    title: "Cloud & Infrastructure",
    desc: "Deployment pipelines, container orchestration, and infrastructure-as-code so releases stop being an event.",
  },
  {
    id: "06",
    title: "Ongoing Support",
    desc: "SLA-backed monitoring, incident response, and maintenance once the system is live — we don't disappear at launch.",
  },
];

export default function Services() {
  return (
    <section id="services" className="section">
      <div className="container">
        <div className="row mb-5">
          <div className="col-lg-7">
            <div className="eyebrow mb-3">What we do</div>
            <h2 className="display-font mb-3" style={{ fontSize: "2.2rem", fontWeight: 600, color: "var(--navy-deep)" }}>
              Six disciplines, one accountable team
            </h2>
          </div>
        </div>
        <div className="row g-4">
          {SERVICES.map((s) => (
            <div className="col-md-6 col-lg-4" key={s.id}>
              <div className="card-system">
                <div className="node-id mb-3">SVC / {s.id}</div>
                <h3 className="display-font mb-3" style={{ fontSize: "1.25rem", fontWeight: 600, color: "var(--navy-deep)" }}>
                  {s.title}
                </h3>
                <p style={{ color: "#4b5b63", lineHeight: 1.65, fontSize: "0.96rem", marginBottom: 0 }}>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
